export default class CreateAccountModel{
    company: string | undefined
    name: string | undefined
    email: string | undefined
    password: string | undefined
    phoneNumber: string | undefined
}